import { gql } from "@apollo/client";
import { ReportJob } from "../fragments";

const QUEUE_REPORT_EXPORT = gql`
  mutation QueueReportExport($input: QueueReportExportInput!) {
    queueReportExport(input: $input) {
      error
      success
      reportJob {
        ${ReportJob}
      }
    }
  }
`;

const SAVE_REPORT_DRAFT = gql`
  mutation SaveReportDraft($input: SaveReportDraftInput!) {
    saveReportDraft(input: $input) {
      error
      success
      reportJob {
        ${ReportJob}
      }
    }
  }
`;

const QUEUE_REPORT_DRAFT = gql`
  mutation QueueReportDraft($id: Int!) {
    queueReportDraft(id: $id) {
      error
      success
      reportJob {
        ${ReportJob}
      }
    }
  }
`;

const RETRY_REPORT_JOB = gql`
  mutation RetryReportJob($id: Int!) {
    retryReportJob(id: $id) {
      error
      success
      reportJob {
        ${ReportJob}
      }
    }
  }
`;

const DELETE_REPORT_JOB = gql`
  mutation DeleteReportJob($id: Int!) {
    deleteReportJob(id: $id) {
      error
      success
    }
  }
`;

const CREATE_REPORT_JOB_EMAIL_ATTACHMENT = gql`
  mutation CreateReportJobEmailAttachment($id: Int!) {
    createReportJobEmailAttachment(id: $id) {
      error
      filename
      size
      success
    }
  }
`;

const ADMIN_CANCEL_REPORT_JOB = gql`
  mutation AdminCancelReportJob($id: Int!) {
    adminCancelReportJob(id: $id) {
      error
      success
      reportJob {
        ${ReportJob}
      }
    }
  }
`;

const ADMIN_RETRY_REPORT_JOB = gql`
  mutation AdminRetryReportJob($id: Int!) {
    adminRetryReportJob(id: $id) {
      error
      success
      reportJob {
        ${ReportJob}
      }
    }
  }
`;

export {
  QUEUE_REPORT_EXPORT,
  SAVE_REPORT_DRAFT,
  QUEUE_REPORT_DRAFT,
  RETRY_REPORT_JOB,
  DELETE_REPORT_JOB,
  CREATE_REPORT_JOB_EMAIL_ATTACHMENT,
  ADMIN_CANCEL_REPORT_JOB,
  ADMIN_RETRY_REPORT_JOB,
};
